import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {IndigoAccountInfo} from './IndigoAccountInfo';
import {IndigoPasswordCard} from './IndigoPasswordCard';
import {IndigoActiveOrders} from './IndigoActiveOrders';
import {IndigoOrderHistory} from './IndigoOrderHistory';
import {CSRCard} from '../Dashboard/CSRCard';
import {IndigoHeader} from './IndigoHeader';
import {IndigoFooter} from './IndigoFooter';
import {CampusFeedback} from '../FlatPages/CampusFeedback';



class DashProps extends Tgcc.BaseProps{
    user: Tgcc.UserInfo;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    backgroundColor:'#F7F5F0'
}
const cardContainerStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
}

const hrzLine:  CSSProperties = {
    width:'984px',
    height:'2px',
    backgroundColor:'#EEEDED',
    margin:'104px auto 20px auto'
}
const hdrDiv: CSSProperties = {
    textAlign:'center',
    marginTop:'50px'
}

const dashHdr: CSSProperties = {
    display: 'flex',
    alignSelf:'center'
}
const link: CSSProperties = {
    backgroundColor:'#616060',
    color:'white',
    width:'175px',
    height:'40px',
    fontFamily:'Reitam',
    marginRight:'15px',
    cursor:'pointer',
    textAlign:'center',
    padding:'0px 25px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    border:'1px solid transparent',
    ':hover': {
        backgroundColor:'#E9E6E6',
        color:'#616060',
        border:'1px solid #616060'
    }
}
let submitBtnStyle : CSSProperties = {
    backgroundColor:'#E27558',
    color:'white',
    width:'300px',
    height:'40px',
    margin:'0px auto 10px',
    textAlign:'center',
    lineHeight:'2.5em',
    fontFamily:'Reitam',
    cursor:'pointer',
    border:'1px solid transparent',
    ':hover': {
        backgroundColor:'white',
        color:'#E27558',
        border:'1px solid grey'
    }
}
const dashHeader: CSSProperties = {
    fontFamily:"AveriaSerifRegular",
    color:'rgba(66, 66, 66, 0.8)',
    letterSpacing:"1px",
    fontSize:'25px',
    marginBottom:'50px'
}

class _IndigoDashboard extends React.Component<DashProps, any>{

    state = {
        compSelected:"Active Orders",
    }
    openStarted = () => {browserHistory.push(Tgcc.Routes.IndigoProofEdit)};
    componentWillMount(){
        if(!this.props.state.LoginData)
            browserHistory.replace(Tgcc.Routes.Root);
    }
    componentDidMount(){
        var tag = document.getElementById('campusDashboard');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    getDashHeader(){
        return (
            <div style={hdrDiv}>
                 <div style={dashHeader}>DASHBOARD</div>
            </div>
        )
    }
    openActive = () => {
        this.setState({compSelected:"Active Orders"})   
    }
    openHistory = () => {
        this.setState({compSelected:"Order History"})        
    }
    openAccountInfo = () => {
        this.setState({compSelected:"Account Info"})        
    }
    openPassword = () => {
        this.setState({compSelected:"Change Password"})
    }
    getComp() {
        switch (this.state.compSelected) {
            case 'Active Orders':
                return <IndigoActiveOrders state={this.props.state} />;
            case 'Order History':
                return <IndigoOrderHistory state={this.props.state} />;
            case 'Account Info':
                return <IndigoAccountInfo state={this.props.state} />;
            case 'Change Password':
                return <IndigoPasswordCard />;
            default:
                return null;
        }
    }
    
    getText(sel:string){
        if(this.state.compSelected === sel ){
            return Object.assign({},link,{textDecoration:'underline',backgroundColor:'#E9E6E6',color:'#616060',border:'1px solid #616060'})
        }
        else {
            return link
        }
    }       
    render() {
        var csrCard = Tgcc.UserIsAdmin(this.props.state) ? <CSRCard /> : null;
        return (
            <div style={wrapperStyle}>
            <div id='campusDashboard'></div>
            <IndigoHeader />
            <CampusFeedback state={this.props.state} />

            {this.getDashHeader()}
            <div style={submitBtnStyle} onClick={this.openStarted}>Start a new proof</div>

            <div style={dashHdr} className="dashLinkDiv">
                <div key={1} onClick={this.openActive} style={this.getText("Active Orders")} className="dashLinks">Active Orders</div>
                <div key={2} onClick={this.openHistory} style={this.getText("Order History")} className="dashLinks">Order History</div>
                <div key={3} onClick={this.openAccountInfo} style={this.getText("Account Info")} className="dashLinks">Update Info</div>
                <div key={4} onClick={this.openPassword} style={this.getText("Change Password")} className="dashLinks">Change Password</div>
            </div>
            <div style={cardContainerStyle} className="compDiv">       
            {this.getComp()}
            {csrCard}
                </div>             
                <div style={hrzLine}>
                </div>
                <IndigoFooter state={this.props.state} />
               
            </div>
        );
    }
} 

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state, user: state.UserInfo};
};
export var IndigoDashboard = connect(mapStateToProps)(Radium(_IndigoDashboard));

